// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oNyW","col":"styles_col__2wwA6","actions":"styles_actions__A5Bri","conflict":"styles_conflict__1kyKh"};